/**
 * RefundSlice Selectors
 * 
 * Memoized selectors for refund state.
 */

import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '../../../app/store';
import { RefundSliceState } from './state';

// Base selector
const selectRefundSlice = (state: RootState): RefundSliceState => state.refund;

// Memoized selectors
export const selectCurrentRefund = createSelector(
  selectRefundSlice,
  (refund) => refund.currentRefund
);

export const selectRefundIsEdited = createSelector(
  selectRefundSlice,
  (refund) => refund.isEdited
);

export const selectRefundEditedFields = createSelector(
  selectRefundSlice,
  (refund) => refund.editedFields
);

export const selectRefundValidationErrors = createSelector(
  selectRefundSlice,
  (refund) => refund.validationErrors
);

export const selectRefundNotes = createSelector(
  selectCurrentRefund,
  (refund) => refund?.notes ?? []
);

export const selectRefundApprovals = createSelector(
  selectCurrentRefund,
  (refund) => refund?.approvals ?? []
);

export const selectRefundDocuments = createSelector(
  selectCurrentRefund,
  (refund) => refund?.documents ?? []
);

export const selectRefundDetail = createSelector(
  selectCurrentRefund,
  (refund) => refund?.refundDetail ?? null
);

export const selectCheckInfo = createSelector(
  selectCurrentRefund,
  (refund) => refund?.checkInfo ?? null
);
